<script setup lang="ts">
import type { ProductDetails } from "mws-ts-v2-sdk";

type Props = {
  product: ProductDetails;
};
const props = defineProps<Props>();

const product = computed(() => props.product);

const beneficiary = computed(() => {
  return product.value?.beneficiary ?? null;
});

const beneficiaryIsCharity = computed(() => {
  return product.value?.beneficiary?.isCharity ?? null;
});

const showPercentage = computed(() => {
  return (
    product.value?.beneficiaryPercentage ||
    product.value?.beneficiary?.beneficiaryPercentage
  );
});
const beneficiaryPercentage = computed(() => {
  return (
    product.value?.beneficiary?.beneficiaryPercentage ||
    beneficiary.value?.beneficiaryPercentage
  );
});
</script>

<template>
  <ProductSidebarUSP
    v-if="beneficiary && beneficiaryIsCharity"
    icon-key="charity"
  >
    <template #title>
      {{ $t("bidProductSidebar.charity.title") }}
    </template>
    <template #description>
      {{
        showPercentage && beneficiaryPercentage
          ? $t("bidProductSidebar.charity.descriptionWithPercentage", {
              PLACEHOLDER_percentage: beneficiaryPercentage,
              PLACEHOLDER_charityName: beneficiary.name,
            })
          : $t("bidProductSidebar.charity.description", {
              PLACEHOLDER_charityName: beneficiary.name,
            })
      }}
    </template>
  </ProductSidebarUSP>
</template>
